<template>
    <div>
        <!-- Filters -->
        <b-card no-body>
            <b-card-header class="pb-50">
                <h5>Filter Beneficiaries</h5>
            </b-card-header>

            <b-card-body>
                <b-row>
                    <span>Beneficiary Type</span>
                    <b-col cols="12" md="12">
                        <b-row>
                            <b-col cols="6" :md="(12 / payables.length)" v-for="payable in payables" :key="payable.beneficiary_type">
                                <b-form-checkbox
                                    v-model="beneficiary_type"
                                    :value="payable.beneficiary_type"
                                    class="custom-control-info"
                                    :checked="beneficiary_type == payable.beneficiary_type"
                                    @change="changePayable"
                                >
                                    <span style="font-size:14px;cursor: pointer;">{{ payable.text }}</span>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr />
                <b-row>
                    <b-col cols="12" md="6" class="mb-md-0 mb-2">
                        <b-row>
                            <b-col cols="12" md="12" class="mb-md-0 mb-2">
                                <administrative-location-filters size="sm" align="horizontal" @filter="changeFilter" />
                            </b-col>
                        </b-row>
                    </b-col>
                    <!-- <b-col cols="12">
                        [{{ selecteds }}]
                    </b-col> -->
                </b-row>
            </b-card-body>
        </b-card>
        <!-- ./Filters -->


        <b-modal
            id="modal-danger"
            ok-variant="danger"
            ok-title="Confirm"
            cancel-title="Cancel"
            modal-class="modal-danger"
            centered
            size="xl"
            title="Beneficiaries Payment List"
            button-size="sm"
            @ok="initiatePayments()"
        >
            <b-card-body>
                <b-row>
                    <b-col cols="12" md="12">
                        <b-table
                            striped
                            hover
                            small
                            ref="records"
                            class="position-relative"
                            :items="selecteds"
                            responsive
                            :fields="modalColumns"
                            primary-key="sale_id"
                            show-empty
                            empty-text="No records found"
                        >
                            <template #cell(rate)="data">
                                <span v-if="data.item.isPercentage">{{ data.item.rate.toLocaleString() }}%</span>
                                <span v-else>{{ data.item.rate.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) }}</span>
                            </template>

                            <template #cell(mass)="data">
                                {{ data.item.mass.toLocaleString() }}
                            </template>

                            <template #cell(value)="data">
                                {{ data.item.value.toLocaleString() }}
                            </template>

                            <template #cell(amount)="data">
                                {{ data.item.amount.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                            </template>

                            <template #cell(loan)="data">
                                {{ data.item.loan.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                            </template>

                            <template #cell(net)="data">
                                {{ data.item.net.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                            </template>

                            <template #cell(paid)="data">
                                {{ data.item.paid.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                            </template>

                            <template #cell(controlNumber)="data">
                                <b-row v-if="data.item.payControl">
                                    <b-col cols="12" md="12">
                                        <b-form-input
                                            :id="'controlNumber_'+data.index"
                                            :name="'controlNumber_'+data.index"
                                            size="sm"
                                            v-model="selecteds[data.index].controlNumber"
                                            auto-focus
                                            style="text-align:right;"
                                        />
                                        <small class="text-danger" v-if="serverErrors && serverErrors.controlNumber">{{ serverErrors.controlNumber[0] }}</small>
                                    </b-col>
                                </b-row>
                                <b-row v-else>
                                    <b-col cols="12" md="12" style="text-align:right;">
                                        N/A
                                    </b-col>
                                </b-row>
                            </template>

                            <template #cell(account)="data">
                                <b-row v-if="data.item.payControl">
                                    <b-col cols="12" md="12">
                                        N/A
                                    </b-col>
                                </b-row>
                                <b-row v-else>
                                    <b-col cols="12" md="12" style="text-align: center;">
                                        {{ data.item.account.number }}/{{ data.item.account.abbreviation }}-{{ data.item.account.bank }}
                                    </b-col>
                                </b-row>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-modal>


        <!-- Table Container Card -->
        <b-card no-body class="mb-0">
            <div class="m-2">
                <!-- Table Top -->
                <b-row>
                    <!-- Search & Button -->
                    <b-col cols="12" md="12">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-button
                                :variant="selecteds.length > 0? 'outline-danger' : 'outline-secondary'"
                                size="sm"
                                :disabled="selecteds.length === 0"
                                v-b-modal.modal-danger
                            >
                                <span class="align-middle">Initiate Pay</span>
                                <feather-icon
                                    icon="SunriseIcon"
                                    class="ml-50"
                                />
                            </b-button>
                        </div>
                    </b-col>
                    <!-- ./Search & Button-->
                </b-row>
                <!-- ./Table Top -->
            </div>

            <!-- Table -->
            <b-table
                striped
                hover
                small
                ref="records"
                class="position-relative"
                :items="beneficiaries"
                responsive
                :fields="columns"
                primary-key="sale_id"
                show-empty
                empty-text="No records found"
                :busy="loading"
            >
                <template #cell(id)="data">
                    <b-form-checkbox
                        :value="data.item"
                        v-model="selecteds"
                        class="custom-control-danger"
                        :disabled="!data.item.isVisible"
                    />
                </template>

                <template #cell(rate)="data">
                    <span v-if="data.item.isPercentage">{{ data.item.rate.toLocaleString() }}%</span>
                    <span v-else>{{ data.item.rate.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) }}</span>
                </template>

                <template #cell(mass)="data">
                    {{ data.item.mass.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </template>

                <template #cell(amount)="data">
                    <span v-if="data.item.ofWeight">
                        <span v-if="data.item.isPercentage">{{ data.item.currency }} {{ (data.item.rate * data.item.mass / 100).toLocaleString() }}</span>
                        <span v-else>{{ data.item.currency }}{{ (data.item.rate * data.item.mass).toLocaleString() }}</span>
                    </span>
                    <span v-else>
                        <span v-if="data.item.isPercentage">{{ data.item.currency }}{{ (data.item.rate * data.item.value / 100).toLocaleString() }}</span>
                        <span v-else>{{ data.item.currency }}{{ (data.item.rate * data.item.value).toLocaleString() }}</span>
                    </span>
                </template>

                <template #cell(value)="data">
                    {{ data.item.value.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                </template>

                <template #cell(paid)="data">
                    {{ data.item.paid.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                </template>

                <template #cell(loan)="data">
                    {{ data.item.loan.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                </template>

                <template #cell(net)="data">
                    {{ data.item.net.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                </template>
            </b-table>
        </b-card>
        <!-- ./Table Container Card -->        
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
    BCard, BCardHeader, BCardBody, BCardText,
    BRow, BCol,
    BForm, BFormGroup, BFormInput, BFormCheckbox, BDropdown, BDropdownItem,
    BButton, BSpinner, BFormSelect, BFormSelectOption,
    BTable, BPagination, BBadge, BAvatar,
    VBModal
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted, computed } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import benefitsStoreModule from '@/views/cromis/payments/benefits/benefitsStoreModule.js'
import AdministrativeLocationFilters from '@core/components/cromis/filters/AdministrativeLocationFilters'

export default {
    props: {},
    components: {
        BCard, BCardHeader, BCardBody, BCardText,
        BRow, BCol,
        BForm, BFormGroup, BFormInput, BFormCheckbox, BDropdown, BDropdownItem, vSelect,
        BButton, BSpinner, BFormSelect, BFormSelectOption,
        BTable, BPagination, BBadge, BAvatar,
        ValidationProvider, ValidationObserver, VBModal,
        AdministrativeLocationFilters,
    },
    directives: {},

    setup(props, context) {
        const dataForm = ref(null)
        const saving = ref(false)
        const loading = ref(false)
        const serverErrors = ref(null)

        const banks = ref([])
        const currencies = ref([])
        const location = ref(null)
        const location_id = ref(null)
        const bank_id = ref(null)
        const currency_id = ref(null)
        const beneficiary_type = ref(false)
        const beneficiaries = ref([])
        const selecteds = ref([])

        const payables = ref([
            { beneficiary_type: 1, text: 'Primary Societies' },
            { beneficiary_type: 2, text: 'Institutions' },
        ])

        const columns = ref([
            { key: 'id', label: '', sortable: false },
            { key: 'name', label: 'Beneficiary', sortable: false, thClass: 'text-left', tdClass: 'text-left' },
            { key: 'benefit', label: 'Benefit', sortable: false },
            { key: 'rate', label: 'Rate', sortable: false, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'mass', label: 'Season KGs', sortable: false, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'value', label: 'Season Value', sortable: false, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'amount', label: 'Amount', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'paid', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'loan', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'net', label: 'Net Pay', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
        ])

        const modalColumns = ref([
            { key: 'name', label: 'Beneficiary', sortable: false },
            { key: 'benefit', label: 'Benefit', sortable: false },
            { key: 'rate', label: 'Rate', sortable: false, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'amount', label: 'Amount', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'paid', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'loan', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'net', label: 'Net Pay', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'controlNumber', label: 'Control Number', sortable: false, thStyle: { width: "9%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'account', label: 'Account Number', sortable: false, thStyle: { width: "15%" }, thClass: 'text-right', tdClass: 'text-right'},
        ])

        const CROMIS_GROUP_STORE_MODULE_NAME = 'cromis-benefits'

        // Register module
        if (!store.hasModule(CROMIS_GROUP_STORE_MODULE_NAME)) store.registerModule(CROMIS_GROUP_STORE_MODULE_NAME, benefitsStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_GROUP_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_GROUP_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            // await store.dispatch('cromis-benefits/getBanks')
            //     .then(response => {
            //         banks.value = response.data.banks
            //     })
            //     .catch(error => {
            //         console.log(error)
            //     })

            // await store.dispatch('cromis-benefits/getCurrencies')
            //     .then(response => {
            //         currencies.value = response.data.currencies
            //     })
            //     .catch(error => {
            //         console.log(error)
            //     })
        })

        const changeFilter = (filteredLocation) => {
            location.value = filteredLocation
            location_id.value = location.value != null && location.value != undefined? location.value.id : null
            filterBeneficiaries()
        }

        const changePayable = () => {
            if(beneficiary_type.value != false){
                filterBeneficiaries()
            }
        }

        const filterBeneficiaries = async () => {
            if (beneficiary_type.value != false && location_id.value != null && location_id.value != undefined) {
                loading.value = true
                await store.dispatch('cromis-benefits/getBeneficiaries', { location_id: location_id.value, beneficiary_type: beneficiary_type.value })
                    .then(response => {
                        beneficiaries.value = response.data.beneficiaries
                        loading.value = false

                        beneficiaries.value = beneficiaries.value.flatMap(beneficiary => {
                            let totalLoan = 0
                            let totalRecovery = 0
                            beneficiary.loans.forEach(loan => {
                                loan.transactions.forEach(transaction => {
                                    if(transaction.sign === "+")
                                        totalLoan += transaction.amount
                                });

                                loan.recoveries.forEach(recovery => {
                                    totalRecovery += recovery.amount
                                });
                            });

                            return beneficiary.benefits.map(benefit => {
                                let account = null
                                let isVisible = true

                                for(let i = 0; i < beneficiary.accounts.length; i++){
                                    if(beneficiary.accounts[i].abbreviation.toLowerCase() === benefit.levy.currency.abbreviation.toLowerCase()){
                                        account = beneficiary.accounts[i]
                                        break;
                                    }
                                }

                                isVisible = benefit.levy.isPercentage
                                            ? parseFloat(((benefit.levy.value / 100) * (benefit.levy.ofWeight? beneficiary.mass : beneficiary.value)).toFixed(3))
                                            : parseFloat((benefit.levy.value * (benefit.levy.ofWeight? beneficiary.mass : beneficiary.value)).toFixed(3));

                                isVisible = isVisible - benefit.paid > 0

                                let amount = benefit.levy.ofWeight
                                        ? (benefit.levy.isPercentage? benefit.levy.value * beneficiary.mass / 100 : benefit.levy.value * beneficiary.mass)
                                        : (benefit.levy.isPercentage? benefit.levy.value * beneficiary.value / 100 : benefit.levy.value * beneficiary.value)

                                return {
                                    id: beneficiary.id,
                                    name: beneficiary.name,
                                    benefit: benefit.levy.name,
                                    payControl: beneficiary.payControl,
                                    controlNumber: null,
                                    account: account,
                                    rate: benefit.levy.value,
                                    currency: benefit.levy.currency.symbol,
                                    isPercentage: benefit.levy.isPercentage,
                                    ofWeight: benefit.levy.ofWeight,
                                    mass: beneficiary.mass,
                                    value: beneficiary.value,
                                    amount: amount,
                                    paid: benefit.paid,
                                    deduction: (totalLoan - totalRecovery),
                                    recovery: totalRecovery,
                                    loan: (totalLoan - totalRecovery),
                                    net: (amount - (totalLoan - totalRecovery) - benefit.paid) < 0? 0 : (amount - (totalLoan - totalRecovery) - benefit.paid),
                                    levy: benefit.levy,
                                    isVisible: isVisible,
                                }
                            })
                        })
                    })
                    .catch(error => {
                        loading.value = false
                        console.log(error)
                    })
            }
        }

        const initiatePayments = async () => {
            let successCount = 0

            for(let i = 0; i < selecteds.value.length; i++){
                await store.dispatch('cromis-benefits/create', {
                    credited_type: beneficiary_type.value,
                    beneficiary_id: selecteds.value[i].id,
                    payment_type: 3,
                    payable_id: selecteds.value[i].levy.id,
                    payControl: selecteds.value[i].payControl,
                    controlNumber: selecteds.value[i].controlNumber,
                    account_id: selecteds.value[i].account != null? selecteds.value[i].account.id : null,
                    mass: selecteds.value[i].mass,
                    value: selecteds.value[i].value,
                    rate: parseFloat(selecteds.value[i].rate),
                    amount: selecteds.value[i].amount,
                    deduction: selecteds.value[i].deduction,
                })
                .then(response => {
                    successCount += 1;
                })
                .catch(error => {
                    if(error.response.status === 422){
                      serverErrors.value = error.response.data.errors
                    }
                    else{
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
            }

            context.root.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                    title: `Payments Initiation Results`,
                    icon: 'CoffeeIcon',
                    variant: selecteds.value.length - successCount === 0? 'success': 'warning',
                    text: selecteds.value.length - successCount === 0? `You have successfully initiated payments for all ${selecteds.value.length} beneficiaries!` : `You managed to initiate payments for ${successCount} out of ${selecteds.value.length} beneficiaries. Please check the rest!`,
                },
            })

            selecteds.value = []

            filterBeneficiaries()
        }

        return {
            // Data
            dataForm,
            saving,
            loading,
            serverErrors,
            banks,
            currencies,
            location_id,
            beneficiary_type,
            selecteds,

            payables,
            beneficiaries,

            // Method
            changeFilter,
            changePayable,
            initiatePayments,

            // Table
            columns,
            modalColumns,
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
